const Parse = global.Parse;
import { Person } from 'domain';
import CommonUtils from 'utils/CommonUtils';

const get = (filters = {}) => {
    const query = new Parse.Query(Person);
    
    if (filters.firstName && filters.lastName) {
        query.equalTo('firstName', filters.firstName);
        query.equalTo('lastName', filters.lastName);
        
        if (filters.email && filters.email.trim() !== '') {
            query.equalTo('email', filters.email);
        }
    } else if (filters.email && filters.email.trim() !== '') {
        query.equalTo('email', filters.email);
    } else {
        return {
            type: 'GET_PERSON',
            meta: { filters },
            payload: Promise.resolve(null)
        };
    }
 
    return {
        type: 'GET_PERSON',
        meta: { filters },
        payload: query.first()
    };
};

const savePersonName = (personData) => {
    return {
        type: 'SAVE_PERSON_NAME',
        payload: (async () => {
            const personName = new Parse.Object('PersonName');
            personName.set('person', CommonUtils.createPointer('Person', personData.person));
            personName.set('name', personData.name);
            return personName.save();
        })()
    };
}

const getAllNamesOfPerson = (personId) => {
    const query = new Parse.Query('PersonName');
    query.equalTo('person', CommonUtils.createPointer('Person', personId));
    return {
        type: 'LIST_PERSON_SYNONYMS',
        meta: {  },
        payload: query.find()
    };
}
 
const list = () => {
    const query = new Parse.Query('PersonName');
    query.include('person');
    
    return {
        type: 'LIST_PERSON',
        meta: {  },
        payload: query.find()
    };
};

const save = (personData) => {
    return {
        type: 'SAVE_PERSON',
        payload: (async () => {
            let person;
            
            if (personData.objectId) {
                const query = new Parse.Query('Person');
                person = await query.get(personData.objectId);
            } else {
                person = new Parse.Object('Person');
            }
            
            person.set('firstName', personData.firstName);
            person.set('lastName', personData.lastName);
            person.set('email', personData.email);
            person.set('deceased', personData.deceased || false);
            await person.save();
            
            if (!personData.objectId) {

            const primaryPersonName = new Parse.Object('PersonName');
            primaryPersonName.set('person', {
                __type: 'Pointer',
                className: 'Person',
                objectId: person.id
            });
            primaryPersonName.set('name', `${personData.firstName} ${personData.lastName}`);
            await primaryPersonName.save();

            let personName = new Parse.Object('PersonName');
            await Promise.all(personData.alternativeNames.map((name) => {
                personName = new Parse.Object('PersonName');
                personName.set('person', {
                    __type: 'Pointer',
                    className: 'Person',
                    objectId: person.id
                });
                personName.set('name', name);
                return personName.save();
            }));
            }
            
            return person;
        })()
    };
};

const saveExpertise = (expertiseData) => {
    return {
        type: 'SAVE_PERSON_EXPERTISE',
        payload: (async () => {
            const expertise = new Parse.Object('PersonExpertise');
            expertise.set('person', CommonUtils.createPointer('Person', expertiseData.person));
            expertise.set('subject', CommonUtils.createPointer('Subject', expertiseData.subject));
            return expertise.save();
        })()
    };
};

const deletePersonExpertise = (personId) => {
    return {
        type: 'DELETE_PERSON_EXPERTISE',
        payload: (async () => {
            const personPointer = CommonUtils.createPointer('Person', personId);
            
            const expertiseQuery = new Parse.Query('PersonExpertise');
            expertiseQuery.equalTo('person', personPointer);
            const personExpertises = await expertiseQuery.find();
            
            if (personExpertises.length > 0) {
                await Parse.Object.destroyAll(personExpertises);
            }
            
            return {
                personId,
                deletedExpertisesCount: personExpertises.length
            };
        })()
    };
};

const deletePerson = (personId) => {
    return {
        type: 'DELETE_PERSON',
        payload: (async () => {
            const personPointer = CommonUtils.createPointer('Person', personId);
            
            const nameQuery = new Parse.Query('PersonName');
            nameQuery.equalTo('person', personPointer);
            const personNames = await nameQuery.find();
            
            const expertiseQuery = new Parse.Query('PersonExpertise');
            expertiseQuery.equalTo('person', personPointer);
            const personExpertises = await expertiseQuery.find();
            
            if (personNames.length > 0) {
                await Parse.Object.destroyAll(personNames);
            }
            if (personExpertises.length > 0) {
                await Parse.Object.destroyAll(personExpertises);
            }
            
            const personQuery = new Parse.Query('Person');
            const person = await personQuery.get(personId);
            await person.destroy();
            
            return {
                personId,
                deletedNamesCount: personNames.length,
                deletedExpertisesCount: personExpertises.length
            };
        })()
    };
};

export default {
    get,
    list,
    save,
    getAllNamesOfPerson,
    saveExpertise,
    deletePersonExpertise,
    savePersonName,
    deletePerson
};